import { render, staticRenderFns } from "./SelectFacebookInteractions.vue?vue&type=template&id=3018620e&"
import script from "./SelectFacebookInteractions.vue?vue&type=script&lang=js&"
export * from "./SelectFacebookInteractions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports